import * as actionTypes from '../constant/appVersion';
import * as req from '../request/appVersion';

//移除目标商行
export function deleteVersionRefer(params) {
  return async (dispatch) => {
    const res = await req.deleteVersionRefer(params);
    if (res) {
      dispatch({ type: actionTypes.APP_VERSION_SAVE, payload: { deleteStallResult: res } });
    }
  };
}
//灰度升级新增关联档口
export function fetchVersionReferAdd(params) {
  return async (dispatch) => {
    const res = await req.getVersionReferAdd(params);
    if (res) {
      dispatch({ type: actionTypes.APP_VERSION_SAVE, payload: { addStallResult: res } });
    }
  };
}
//获取灰度发版的商行列表
export function fetchTradingCompanyList(params) {
  return async (dispatch) => {
    const res = await req.getTradingCompanyList(params);
    if (res) {
      dispatch({
        type: actionTypes.APP_VERSION_SAVE,
        payload: { grayReleasedTradingCompanyList: res.data },
      });
    }
  };
}
//
export function fetchAppList(params) {
  return async (dispatch) => {
    const res = await req.getAppList(params);
    if (res) {
      dispatch({ type: actionTypes.APP_VERSION_SAVE, payload: { appListData: res.data } });
    }
  };
}
//
export function fetchSaveOrUpdateVer(params) {
  return async (dispatch) => {
    const res = await req.saveOrUpdateVer(params);
    if (res) {
      dispatch({ type: actionTypes.APP_VERSION_SAVE, payload: { saveOrUpdateVerData: res } });
    }
  };
}
//
export function fetchAppVerById(params) {
  return async (dispatch) => {
    const res = await req.getAppVerById(params);
    if (res) {
      dispatch({ type: actionTypes.APP_VERSION_SAVE, payload: { appVerByIdData: res.data } });
    }
  };
}

export function clearData() {
  return async (dispatch) => {
    dispatch({ type: actionTypes.APP_VERSION_CLEAR });
  };
}
